import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  signal,
  WritableSignal,
  inject,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CrudOperation } from '@shared/models';
import { AppNotificationService } from '@shared/services';
import { QueryOptions } from 'odata-query';
import {
  Collection,
  EntityType,
  GridItemCreateEvent,
  GridItemUpdateEvent,
} from '../../models';
import { EntityTypeService } from '../../services';

@Component({
  standalone: false,
  selector: 'gstar-entity-types-page',
  templateUrl: 'entity-types-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EntityTypesPageComponent implements OnInit {
  private entityTypesService = inject(EntityTypeService);
  private appNotificationService = inject(AppNotificationService);
  private translateService = inject(TranslateService);

  public entityTypes: WritableSignal<Collection<EntityType>> = signal({
    total: 0,
    items: [],
  });

  public query: Partial<QueryOptions<EntityType>> = {
    count: true,
    top: 10,
    skip: 0,
  };

  private entityTypeName = this.translateService.instant(
    'admin.dashboard.entityTypesTitle'
  );

  ngOnInit(): void {
    this.fetchEntityTypes();
  }

  create(entityTypeGridItem: GridItemCreateEvent<EntityType>): void {
    let isSuccess = false;

    this.entityTypesService.create(entityTypeGridItem.item).subscribe(() => {
      entityTypeGridItem.onSuccess();
      isSuccess = true;

      this.fetchEntityTypes();

      this.appNotificationService.crudNotify(
        CrudOperation.Create,
        this.entityTypeName,
        isSuccess
      );
    });
  }

  update(entityTypeGridItem: GridItemUpdateEvent<EntityType>): void {
    let isSuccess = false;
    this.entityTypesService.update(entityTypeGridItem.item).subscribe(() => {
      entityTypeGridItem.onSuccess();
      isSuccess = true;
      this.fetchEntityTypes();

      this.appNotificationService.crudNotify(
        CrudOperation.Update,
        this.entityTypeName,
        isSuccess
      );
    });
  }

  queryUpdate(entityTypeGridItem: Partial<QueryOptions<EntityType>>): void {
    this.query = entityTypeGridItem;
    this.fetchEntityTypes();
  }

  private fetchEntityTypes(): void {
    this.entityTypesService
      .get({ ...this.query, count: true })
      .subscribe((entityTypeCollection: Collection<EntityType>) => {
        this.entityTypes.set(entityTypeCollection);
      });
  }
}
